import React from "react";
import useSundayCountdown from "@/hooks/useSundayCountdown";

function Pad({ value, label }) {
  return (
    <div className="giveaway-countdown__cell">
      <span className="giveaway-countdown__num font-display">
        {String(value).padStart(2, "0")}
      </span>
      <span className="giveaway-countdown__label">{label}</span>
    </div>
  );
}

export default function GiveawayCountdown() {
  const { days, hours, minutes, seconds, done } = useSundayCountdown();

  return (
    <div className="giveaway-countdown" data-testid="giveaway-countdown">
      <p className="text-[#8B9CC7] text-xs uppercase tracking-widest mb-2">
        Announcement seterusnya
      </p>
      {done ? (
        <p className="font-display text-lg text-[#E9FF00] font-bold">
          Announcement hari ini!
        </p>
      ) : (
        <div className="giveaway-countdown__grid">
          <Pad value={days} label="Hari" />
          <span className="giveaway-countdown__sep">:</span>
          <Pad value={hours} label="Jam" />
          <span className="giveaway-countdown__sep">:</span>
          <Pad value={minutes} label="Min" />
          <span className="giveaway-countdown__sep">:</span>
          <Pad value={seconds} label="Saat" />
        </div>
      )}
      <p className="text-[#8B9CC7] text-[11px] mt-2">Setiap Ahad · Percuma · No payment</p>
    </div>
  );
}
